var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-cropper',{ref:"cropper",attrs:{"img":_vm.img}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }